import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AuthContext } from '../AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

type AuthWrapperProps = { children?: React.ReactNode | undefined };

const AuthWrapper = ({ children }: AuthWrapperProps) => {
    const authContext = useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    let nextUrl = useMemo(() => {
        const pathname = encodeURIComponent(location.pathname + location.search + location.hash);
        return !pathname.includes('/sign-in') && !pathname.includes('unauthorised') && !authContext.loggedOut
            ? `?next=${pathname}`
            : '';
    }, [location.hash, location.pathname, location.search, authContext.loggedOut]);

    useEffect(() => {
        if (authContext.loading) {
            return;
        } else if (
            !authContext.authenticated &&
            !location.pathname.includes('/confirm-password/') &&
            !location.pathname.includes('/forgot-password/') &&
            !location.pathname.includes('/sign-in')
        ) {
            navigate(`/sign-in${nextUrl}`);
        } else {
            setIsAuthenticated(true);
        }
    }, [authContext, location, nextUrl, navigate]);

    return isAuthenticated ? <>{children}</> : null;
};

export default AuthWrapper;
